import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { FunctionComponent } from 'react';

const FeelingAnxious: FunctionComponent = () => {
  return (
    <Box className="py-8">
      <Typography variant="body1">
        It's okay to feel anxious, upset, scared, or a just little off sometimes. It's also okay for these feelings to be more intense after a trauma like sexual assault. Below are some suggestions
        for what to do if you're feeling overwhelmed.
      </Typography>
      <Typography variant="body1" className="font-bold pt-4">
        What can help when you are feeling anxious or scared:
      </Typography>
      <Typography variant="body1">
        <ul className="rhs-hotlines-list">
          <li>Tell yourself that you are safe. Remind yourself that the actual event is over and that you survived.</li>
          <li>
            Breathe.
            <ul className="rhs-hotlines-list">
              <li>
                Take slow, deep breaths by placing your hand on your stomach and taking deep breaths. You should see your hand move out with the inhalations, and watch it fall in with the exhalations.
              </li>
              <li>
                When we panic, our body begins to take short, shallow breaths, and the decrease in oxygen can make you feel more panicked. Deep breathing is important because it increases the oxygen
                in your system and helps you move out of anxious state faster.
              </li>
            </ul>
          </li>
          <li>
            Return to the present by using the five senses.
            <ul className="rhs-hotlines-list">
              <li>Sight: Look around you. Make a list of the items in the room; count the colors or pieces of furniture around you. What do you see?</li>
              <li>Smell: Breathe in a comforting scent, or focus on the smells around you. What do you smell?</li>
              <li>Hearing: Listen to the noises around you, or turn on music. What do you hear?</li>
              <li>Taste: Eat or drink something you enjoy. Focus on the flavor. What do you taste?</li>
              <li>Touch: Hold something cold, like a piece of ice, or hot, like a mug of tea. What does it feel like?</li>
            </ul>
          </li>
          <li>
            Recognize what would make you feel safer.
            <ul className="rhs-hotlines-list">
              <li>Wrap yourself in a blanket, get a stuffed animal, sit with your pet or go into a room by yourself and close the door. Do whatever it takes for you to feel secure.</li>
            </ul>
          </li>
          <li>
            Call someone for support. You don't have to go through this alone. If you have a friend or family member who you trust, reach out to them. You've made the right choice by coming to the
            Online Hotline—someone is waiting to help you. If you want to talk to someone immediately, you can always call the {process.env.NX_ORGANIZATION_NAME} Hotline at 800.656.HOPE (4673) to
            speak to someone who is trained to help in your community.
          </li>
        </ul>
      </Typography>
    </Box>
  );
};
export default FeelingAnxious;
